var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Oops, it appears you don't have permissions to view this page")]),_c('i',{staticClass:"fas fa-frown"})])}]

export { render, staticRenderFns }